import { ProjectSliceType } from 'src/core/models'

const projectsState: ProjectSliceType = {
  createProject: {
    loading: false,
    success: false,
    response: {
      id: null,
      volume_credits: null
    }
  },
  validateProjectId: {
    loading: false,
    response: null,
    project: null,
  },
  validateProjectIdForStockSale: {
    loading: false,
    response: null
  },
  createPurchaseOperation: {
    loading: false,
    success: false,
    error: null
  },
  createBrokerageOperation: {
    loading: false,
    success: false,
    error: null,
    newPurchaseLink: null
  },
  userProjects: {
    loading: false,
    data: [],
    filterText: null,
    filterType: 'ALL'
  },
  projectDetails: {
    loading: false,
    project: null
  },
  transferProject: {
    loading: false,
    success: false,
    error: null
  },
  createBigProject: {
    loading: false,
    newProjectId: null,
    error: null
  },
  editBigProject: {
    loading: false,
    success: null,
    error: null
  },
  projectForm: {
    activeStep: 'DEFINITION',
    kind: null,
    is_active: false,
    latitude: null,
    longitude: null,
    country: null,
    locationText: '',
    name: null,
    url: null,
    sdg_compliances: [],
    description_en: null,
    description_es: null,
    description_fr: null,
    description_ko: null,
    description_pt: null,
    description_de: null,
    description_it: null,
    description_pl: null,
    description_zh: null,
    registered_since: null,
    video: null,
    thumbnail: null,
    cover: null,
    main_image: null,
    pictures: [],
    contributionProjectType: 'CONTRIBUTION_UNIT',
    contribution_unit: null,
    price: null,
    currency_token: null,
    volume_credits: null,
    is_vintage: false,
    vintage_items: [],
    currentVintage: null,
    is_tax_relief: false,
    tax_info_en: null,
    tax_info_es: null,
    tax_info_fr: null,
    tax_info_ko: null,
    tax_info_pt: null,
    tax_info_de: null,
    tax_info_it: null,
    tax_info_pl: null,
    tax_info_zh: null,
    status: null,
    type: null,
    sub_type: null,
    methodology: null,
    mechanism: null,
    energy_type: null,
    central_name: null,
    standard_energy_type: null,
    validator: null,
    first_verifier: null,
    standard: null,
    stage: null,
    credit_start: null,
    credit_end: null,
    registry_depositing_id: null,
    registry_depositing_name: null,
    registry_depositing_url: null,
    credits_certificate: null,
    pdd: null,
    validation_report: null,
    monitoring_report: null,
    verification_report: null,
    is_property_of_climatetrade: false,
    billing_company_name: null,
    billing_vat_number: null,
    billing_address: null,
    billing_city: null,
    billing_state: null,
    billing_postal_code: null,
    billing_country: null,
    device_registration_request: null,
    resulting_from_the_issuer: null,
    start_up_date_of_installation: null,
    headline_en: null,
    headline_es: null,
    headline_fr: null,
    headline_ko: null,
    headline_pt: null,
    headline_de: null,
    headline_it: null,
    headline_pl: null,
    headline_zh: null,
    discounts: [],
    currentDiscount: null,
    type_of_biome_ecosystem: null,
    protocol_implementation_scheme: null,
    executive_summary: null,
    additional_documentation: null,
    complementary_standards: null,
    quantification_methodology: null,
    insurance_documentation: null
  }
}

export { projectsState as initialState }
